import { createRouter, createWebHistory } from 'vue-router';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'web',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/Web'),
    },
  ],
});
